import AiImageCreatorEntryPoint from './aiImageCreatorEntryPoint';

export default AiImageCreatorEntryPoint;
